module.exports = __webpack_public_path__ + "staticcomp/img/top_main_bt.097cf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_main_bt.png
// module id = vomH
// module chunks = 39